// Tabs logic (generic)
let _classCardRaf = 0;
function equalizeClassCardHeights(){
  const cards = Array.from(document.querySelectorAll('#classes .grid .card'));
  if(cards.length === 0) return;

  // Always reset first so we can measure natural heights / allow single-column layouts to flow naturally.
  cards.forEach(c => { c.style.height = 'auto'; });

  // Only equalize when we're in the multi-column layout.
  // (The CSS turns on 3 columns at 900px; on mobile this would create lots of blank space.)
  const shouldEqualize = window.matchMedia('(min-width: 900px)').matches;
  if(!shouldEqualize) return;

  const max = Math.max(...cards.map(c => c.getBoundingClientRect().height));
  const h = Math.ceil(max);
  cards.forEach(c => { c.style.height = h + 'px'; });
}
function scheduleEqualizeClassCardHeights(){
  if(_classCardRaf) cancelAnimationFrame(_classCardRaf);
  _classCardRaf = requestAnimationFrame(() => {
    _classCardRaf = 0;
    equalizeClassCardHeights();
  });
}

// Points (XLSX -> table)
function normalizeHeader(s){
  return String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function findHeaderIndex(headerNorm, headers){
  const candidates = Array.isArray(headers) ? headers : [headers];
  for(let i = 0; i < candidates.length; i++){
    const idx = headerNorm.indexOf(normalizeHeader(candidates[i]));
    if(idx >= 0) return idx;
  }
  return -1;
}

function parsePointsRows({ rows, driverHeader, pointsHeader }){
  if(!Array.isArray(rows) || rows.length === 0) return null;

  const header = rows[0].map(h => String((h === null || h === undefined) ? '' : h).trim());
  const headerNorm = header.map(normalizeHeader);

  const driverIdx = findHeaderIndex(headerNorm, driverHeader);
  const pointsIdx = findHeaderIndex(headerNorm, pointsHeader);
  if(driverIdx < 0 || pointsIdx < 0) return null;

  const eventCols = [];
  for(let i = 0; i < header.length; i++){
    if(i === driverIdx || i === pointsIdx) continue;
    if(!header[i]) continue;
    eventCols.push({ idx: i, name: header[i] });
  }

  const entries = rows
    .slice(1)
    .map(r => {
      const driver = String((r && r[driverIdx] !== null && r[driverIdx] !== undefined) ? r[driverIdx] : '').trim();
      const total = Number((r && r[pointsIdx] !== null && r[pointsIdx] !== undefined) ? r[pointsIdx] : 0);

      const events = [];
      for(let j = 0; j < eventCols.length; j++){
        const c = eventCols[j];
        const v = (r && r[c.idx] !== null && r[c.idx] !== undefined) ? r[c.idx] : null;
        events.push(v);
      }

      return { driver, total, events };
    })
    .filter(e => e.driver && Number.isFinite(e.total));

  entries.sort((a, b) => b.total - a.total);

  return { entries, eventCols };
}

function normalizeStandingsClassKey(s){
  return String(s || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
}

// Current year standings fallback (pre-season / no data configured)
function renderCurrentYearTbdStandings(message){
  const mount = document.getElementById('points-current-grid');
  if(!mount) return;

  const tableHost = document.getElementById('points-current-table');
  const status = document.getElementById('points-current-status');
  if(tableHost) tableHost.innerHTML = '';
  if(status){
    status.hidden = false;
    status.textContent = message || 'Standings will populate after the first event. Until then, each class is marked TBD.';
  }

  const classCards = Array.from(document.querySelectorAll('#classes .grid > article.card, #classes .grid > .card'));
  if(classCards.length === 0){
    mount.innerHTML = '<div class="card"><h3>Standings</h3><p class="muted">No classes found.</p></div>';
    return;
  }

  // Lil' Titans is not a points class — keep it out of points standings.
  const excludedStandingsClasses = new Set(['liltitans']);

  const classes = classCards.map(card => {
    const name = (card.querySelector('h3')?.textContent || '').trim();
    const tagEl = card.querySelector('.tag');
    const tag = (tagEl?.textContent || '').trim();
    const tagClass = tagEl ? tagEl.className : 'tag';
    const href = card.querySelector('a.btn.primary')?.getAttribute('href') || '';
    return { name, tag, tagClass, href };
  }).filter(c => c.name && !excludedStandingsClasses.has(normalizeStandingsClassKey(c.name)));

  mount.innerHTML = '';

  for(const c of classes){
    const el = document.createElement('div');
    el.className = 'card standings-card standings-tbd';

    const top = document.createElement('div');
    top.className = 'row between standings-head';

    const h3 = document.createElement('h3');
    h3.textContent = c.name;
    top.appendChild(h3);

    if(c.tag){
      const pill = document.createElement('span');
      pill.className = c.tagClass || 'tag';
      pill.textContent = c.tag;
      top.appendChild(pill);
    }

    el.appendChild(top);

    const tbd = document.createElement('div');
    tbd.className = 'standings-tbd-hero';
  tbd.innerHTML = '<div class="tbd-badge">TBD</div><div class="muted">No points yet — check back after Race 1.</div>';
    el.appendChild(tbd);

    const sk = document.createElement('div');
    sk.className = 'standings-skel';
    sk.innerHTML =
      '<div class="standings-skel-head"><span>#</span><span>Racer</span><span class="right">Pts</span></div>' +
      '<div class="standings-skel-row"><span class="skel"></span></div>' +
      '<div class="standings-skel-row"><span class="skel"></span></div>' +
      '<div class="standings-skel-row"><span class="skel"></span></div>';
    el.appendChild(sk);

    const actions = document.createElement('div');
    actions.className = 'row standings-actions';

    if(c.href){
      const a = document.createElement('a');
      a.className = 'btn';
      a.href = c.href;
      a.textContent = 'Class Info';
      actions.appendChild(a);
    }

    el.appendChild(actions);
    mount.appendChild(el);
  }
}

function getClassMetaByKey(){
  const meta = new Map();
  const classCards = Array.from(document.querySelectorAll('#classes .grid > article.card, #classes .grid > .card'));
  for(const card of classCards){
    const name = (card.querySelector('h3')?.textContent || '').trim();
    if(!name) continue;
    const tagEl = card.querySelector('.tag');
    meta.set(normalizeStandingsClassKey(name), {
      name,
      tag: (tagEl?.textContent || '').trim(),
      tagClass: tagEl ? tagEl.className : 'tag',
      href: card.querySelector('a.btn.primary')?.getAttribute('href') || ''
    });
  }
  return meta;
}

function findClassMeta(pointsClass, classMeta){
  const className = String(pointsClass && pointsClass.className ? pointsClass.className : '').trim();
  const key = normalizeStandingsClassKey(className);
  if(classMeta.has(key)) return classMeta.get(key);

  for(const [candidateKey, meta] of classMeta.entries()){
    if(key.includes(candidateKey) || candidateKey.includes(key)) return meta;
  }

  if(key.includes('risingtitans')) return classMeta.get('risingtitans') || null;
  if(key.includes('ntsmalltire') && !key.includes('xtreme') && !key.includes('zeus')) return classMeta.get('titansntsmalltire') || null;
  if(key.includes('xtreme')) return classMeta.get('titansxtrementsmalltire') || null;
  if(key.includes('zeus')) return classMeta.get('zeussrageoutlawntsmalltire') || null;

  return null;
}

function renderCurrentYearPointsData(data){
  const mount = document.getElementById('points-current-grid');
  const tableHost = document.getElementById('points-current-table');
  const status = document.getElementById('points-current-status');
  if(!mount) return false;

  const classes = (data && Array.isArray(data.classes)) ? data.classes : [];
  if(classes.length === 0) return false;

  if(tableHost) tableHost.innerHTML = '';
  mount.innerHTML = '';
  if(status){
    status.hidden = false;
    status.textContent = data.title || 'Current year points standings';
  }

  const classMeta = getClassMetaByKey();
  const orderedClasses = classes.slice().sort((a, b) => {
    const aEntries = Array.isArray(a.entries) ? a.entries.length : 0;
    const bEntries = Array.isArray(b.entries) ? b.entries.length : 0;
    return bEntries - aEntries;
  });

  for(const pointsClass of orderedClasses){
    const className = String(pointsClass.className || 'Standings').trim();
    const meta = findClassMeta(pointsClass, classMeta);
    const entries = (Array.isArray(pointsClass.entries) ? pointsClass.entries : [])
      .slice()
      .sort((a, b) => Number(b.totalPoints || 0) - Number(a.totalPoints || 0));

    const el = document.createElement('div');
    el.className = 'card standings-card standings-live';

    const top = document.createElement('div');
    top.className = 'row between standings-head';

    const h3 = document.createElement('h3');
    h3.textContent = className;
    top.appendChild(h3);

    if(meta && meta.tag){
      const pill = document.createElement('span');
      pill.className = meta.tagClass || 'tag';
      pill.textContent = meta.tag;
      top.appendChild(pill);
    }

    el.appendChild(top);

    const tableWrap = document.createElement('div');
    tableWrap.className = 'points-pager-tablewrap current-points-tablewrap';

    const table = document.createElement('table');
    table.innerHTML = '<thead><tr><th>#</th><th>Racer</th><th>No.</th><th>Show</th><th>Wins</th><th>RU</th><th>W</th><th>Pts</th></tr></thead>';
    const tbody = document.createElement('tbody');

    for(let i = 0; i < entries.length; i++){
      const entry = entries[i];
      const tr = document.createElement('tr');
      const cells = [
        i + 1,
        entry.name || '-',
        entry.raceNumber || '-',
        entry.showUp ?? '-',
        entry.roundWins ?? '-',
        entry.runnerUp ?? '-',
        entry.winner ?? '-',
        entry.totalPoints ?? 0
      ];

      for(const cell of cells){
        const td = document.createElement('td');
        td.textContent = String(cell);
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    }

    table.appendChild(tbody);
    tableWrap.appendChild(table);
    el.appendChild(tableWrap);

    if(meta && meta.href){
      const actions = document.createElement('div');
      actions.className = 'row standings-actions';
      const a = document.createElement('a');
      a.className = 'btn';
      a.href = meta.href;
      a.textContent = 'Class Info';
      actions.appendChild(a);
      el.appendChild(actions);
    }

    mount.appendChild(el);
  }

  return true;
}

async function renderCurrentYearStandingsFromXlsx(){
  const host = document.getElementById('points-current-table');
  const status = document.getElementById('points-current-status');
  const fallbackGrid = document.getElementById('points-current-grid');
  if(!host) return;

  const pointsSection = document.getElementById('points');
  const xlsxUrl =
    (window.__COTT__ && window.__COTT__.pointsCurrentXlsxUrl) ||
    (pointsSection && pointsSection.getAttribute('data-points-current-xlsx')) ||
    '';
  const jsonUrl =
    (window.__COTT__ && window.__COTT__.pointsCurrentJsonUrl) ||
    (pointsSection && pointsSection.getAttribute('data-points-current-json')) ||
    '';

  if(!xlsxUrl){
    if(!jsonUrl){
      renderCurrentYearTbdStandings();
      return;
    }

    try {
      if(status){
        status.hidden = false;
        status.textContent = 'Loading current year standings…';
      }
      const res = await fetch(jsonUrl, { cache: 'no-cache' });
      if(!res.ok) throw new Error('Failed to fetch standings (' + res.status + ')');
      const data = await res.json();
      if(!renderCurrentYearPointsData(data)) throw new Error('No standings found');
      window._pointsCurrentData = data;
    } catch (err) {
      const msg = (err && err.message) ? err.message : String(err);
      renderCurrentYearTbdStandings('Unable to load current standings: ' + msg);
      // eslint-disable-next-line no-console
      console.warn('[points] current standings JSON load failed:', err);
    }
    return;
  }

  try {
    // If opened directly from disk, many browsers block/hang local fetch() calls.
    if (window.location && window.location.protocol === 'file:') {
      renderCurrentYearTbdStandings('To load the current standings, open this site from a web server (not a file). Example: run "python -m http.server" in the project folder, then visit http://localhost:8000.');
      return;
    }

    if(typeof window.XLSX === 'undefined') throw new Error('XLSX library not loaded');

    if(status){
      status.hidden = false;
      status.textContent = 'Loading current year standings…';
    }

    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeoutMs = 15000;
    const to = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;

    const res = await fetch(xlsxUrl, {
      cache: 'no-cache',
      signal: controller ? controller.signal : undefined
    });

    if(to) clearTimeout(to);
    if(!res.ok) throw new Error('Failed to fetch standings (' + res.status + ')');
    const buf = await res.arrayBuffer();

    const wb = window.XLSX.read(buf, { type: 'array' });
    const sheetName = (wb.SheetNames && wb.SheetNames[0]) ? wb.SheetNames[0] : null;
    if(!sheetName) throw new Error('No sheets found in workbook');

    const ws = wb.Sheets[sheetName];
    const rows = window.XLSX.utils.sheet_to_json(ws, { header: 1, defval: null });

    const parsed = parsePointsRows({
      rows,
      driverHeader: ['Racer Name', 'Driver Name', 'Driver', 'Racer'],
      pointsHeader: ['Total Points', 'Points', 'Total']
    });
    if(!parsed) throw new Error('Could not locate racer and total points columns');

    const view = buildPagedPointsView({ parsed, pageSize: 10 });
    if(!view) throw new Error('Could not build standings table');

    host.innerHTML = '';
    const card = document.createElement('div');
    card.className = 'card';
    card.appendChild(view);
    host.appendChild(card);
    if(fallbackGrid) fallbackGrid.innerHTML = '';
    if(status) status.hidden = true;

    window._pointsCurrentParsed = parsed;
  } catch (err) {
    const msg = (err && err.message) ? err.message : String(err);
    renderCurrentYearTbdStandings('Unable to load current standings: ' + msg);
    // eslint-disable-next-line no-console
    console.warn('[points] current standings load failed:', err);
  }
}

function buildPagedPointsView({ parsed, pageSize }){
  if(!parsed) return null;

  const entries = parsed.entries || [];
  const eventCols = parsed.eventCols || [];
  const size = pageSize || 10;

  const root = document.createElement('div');
  root.className = 'points-pager';

  const controls = document.createElement('div');
  controls.className = 'row between points-pager-controls';

  const left = document.createElement('div');
  left.className = 'row';

  const btnPrev = document.createElement('button');
  btnPrev.className = 'btn';
  btnPrev.type = 'button';
  btnPrev.textContent = '◀ Prev';

  const btnNext = document.createElement('button');
  btnNext.className = 'btn';
  btnNext.type = 'button';
  btnNext.textContent = 'Next ▶';

  const meta = document.createElement('span');
  meta.className = 'muted';

  left.appendChild(btnPrev);
  left.appendChild(btnNext);
  controls.appendChild(left);
  controls.appendChild(meta);
  root.appendChild(controls);

  const tableWrap = document.createElement('div');
  tableWrap.className = 'points-pager-tablewrap';
  root.appendChild(tableWrap);

  const table = document.createElement('table');
  tableWrap.appendChild(table);

  const thead = document.createElement('thead');
  const trh = document.createElement('tr');
  trh.innerHTML = '<th>#</th><th>Racer</th>';
  for(let i = 0; i < eventCols.length; i++){
    const th = document.createElement('th');
    th.textContent = eventCols[i].name;
    trh.appendChild(th);
  }
  const thTotal = document.createElement('th');
  thTotal.textContent = 'Total Points';
  trh.appendChild(thTotal);
  thead.appendChild(trh);
  table.appendChild(thead);

  const tbody = document.createElement('tbody');
  table.appendChild(tbody);

  function formatCellValue(v){
    if(v === null || v === undefined) return '-';
    const s = String(v);
    if(s.trim() === '') return '-';
    return s;
  }

  let page = 0;
  const pageCount = Math.max(1, Math.ceil(entries.length / size));

  function clampPage(p){
    if(p < 0) return 0;
    if(p > pageCount - 1) return pageCount - 1;
    return p;
  }

  function render(){
    page = clampPage(page);
    const start = page * size;
    const end = Math.min(entries.length, start + size);

    // Update meta + buttons
    if(entries.length === 0) meta.textContent = 'No standings found.';
    else meta.textContent = 'Showing ' + (start + 1) + '–' + end + ' of ' + entries.length;

    btnPrev.disabled = (page <= 0);
    btnNext.disabled = (page >= pageCount - 1);

    // Render rows
    tbody.innerHTML = '';
    for(let i = start; i < end; i++){
      const e = entries[i];
      const tr = document.createElement('tr');

      const tdRank = document.createElement('td');
      tdRank.textContent = String(i + 1);
      tr.appendChild(tdRank);

      const tdDriver = document.createElement('td');
      tdDriver.textContent = e.driver;
      tr.appendChild(tdDriver);

      for(let j = 0; j < eventCols.length; j++){
        const td = document.createElement('td');
        const v = (e.events && e.events.length > j) ? e.events[j] : null;
        td.textContent = formatCellValue(v);
        tr.appendChild(td);
      }

      const tdTotal = document.createElement('td');
      tdTotal.textContent = String(e.total);
      tr.appendChild(tdTotal);

      tbody.appendChild(tr);
    }
  }

  btnPrev.addEventListener('click', () => { page = clampPage(page - 1); render(); });
  btnNext.addEventListener('click', () => { page = clampPage(page + 1); render(); });

  // Swipe left/right on controls to change pages (mobile).
  // (Table itself needs horizontal scroll for many race columns.)
  let touchStartX = null;
  let touchStartY = null;

  function onTouchStart(e){
    const t = e.touches && e.touches[0];
    if(!t) return;
    touchStartX = t.clientX;
    touchStartY = t.clientY;
  }

  function onTouchEnd(e){
    if(touchStartX === null || touchStartY === null) return;
    const t = e.changedTouches && e.changedTouches[0];
    if(!t) return;
    const dx = t.clientX - touchStartX;
    const dy = t.clientY - touchStartY;
    touchStartX = null;
    touchStartY = null;

    if(Math.abs(dx) < 60) return;
    if(Math.abs(dx) < Math.abs(dy)) return;

    if(dx < 0) page = clampPage(page + 1);
    else page = clampPage(page - 1);
    render();
  }

  controls.addEventListener('touchstart', onTouchStart, { passive: true });
  controls.addEventListener('touchend', onTouchEnd, { passive: true });

  render();
  return root;
}

function getEventPointsValue(entry, eventIndex){
  const v = (entry && entry.events && entry.events.length > eventIndex) ? entry.events[eventIndex] : null;
  if(v === null || v === undefined) return null;
  const n = Number(v);
  if(!Number.isFinite(n)) return null;
  return n;
}

function sanitizeFilename(s){
  return String(s || '')
    .replace(/[\\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function generateRacePointsPdf({ parsed, eventIndex }){
  if(!parsed || !parsed.eventCols || !parsed.entries) return;
  const eventCol = (parsed.eventCols.length > eventIndex) ? parsed.eventCols[eventIndex] : null;
  if(!eventCol) return;

  if(!window.jspdf || !window.jspdf.jsPDF){
    throw new Error('PDF library not loaded');
  }

  const jsPDF = window.jspdf.jsPDF;
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });

  const title = String(eventCol.name || ('Race #' + (eventIndex + 1)));
  const filename = sanitizeFilename('2025 ' + title + ' Points.pdf') || '2025 Race Points.pdf';

  const rows = parsed.entries
    .map(e => ({ driver: e.driver, points: getEventPointsValue(e, eventIndex) }))
    .filter(r => r.points !== null && r.points > 0)
    .sort((a, b) => b.points - a.points);

  const pageW = doc.internal.pageSize.getWidth();
  const marginX = 40;
  let y = 52;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(title + ' — Points Earners', marginX, y);
  y += 20;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Generated from 2025 points standings', marginX, y);
  y += 18;

  // Header
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('#', marginX, y);
  doc.text('Driver', marginX + 30, y);
  doc.text('Points', pageW - marginX - 40, y, { align: 'right' });
  y += 10;
  doc.setDrawColor(120);
  doc.line(marginX, y, pageW - marginX, y);
  y += 16;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);

  if(rows.length === 0){
    doc.text('No points recorded for this race yet.', marginX, y);
  } else {
    const lineH = 16;
    const maxY = doc.internal.pageSize.getHeight() - 54;

    for(let i = 0; i < rows.length; i++){
      if(y > maxY){
        doc.addPage();
        y = 52;
        doc.setFont('helvetica', 'bold');
        doc.text(title + ' — Points Earners (cont.)', marginX, y);
        y += 24;
        doc.setFont('helvetica', 'normal');
      }

      const rank = String(i + 1);
      const driver = String(rows[i].driver || '-');
      const points = String(rows[i].points);

      doc.text(rank, marginX, y);
      doc.text(driver, marginX + 30, y, { maxWidth: pageW - (marginX * 2) - 90 });
      doc.text(points, pageW - marginX - 40, y, { align: 'right' });
      y += lineH;
    }
  }

  doc.save(filename);
}

function populatePastRaces2025Cards(parsed){
  const cards = Array.from(document.querySelectorAll('#media .card[data-points-race-index]'));
  if(cards.length === 0) return;

  // Only fill the first 5 event columns to match the 5 cards.
  const eventCols = (parsed && parsed.eventCols) ? parsed.eventCols : [];

  for(let i = 0; i < cards.length; i++){
    const card = cards[i];
    const idx = Number(card.getAttribute('data-points-race-index'));
    if(!Number.isFinite(idx)) continue;

    const titleEl = card.querySelector('[data-role="race-title"]');
    if(titleEl){
      const raceNum = idx + 1;
      const raceLabel = 'Race ' + raceNum;

      // Prefer the XLSX column header name when present, but strip any leading "Round X"/"Race X"
      // so we don't end up with "Race 1 • Round 1" or duplicate labels.
      const raw = (eventCols[idx] && eventCols[idx].name) ? String(eventCols[idx].name).trim() : '';
      const prefixRe = new RegExp('^(?:round|race)\\s*' + raceNum + '\\s*(?:[•\\-–—:|]\\s*)?', 'i');
      const cleaned = raw.replace(prefixRe, '').trim();

      if(cleaned){
        titleEl.textContent = raceLabel + ' • ' + cleaned;
      } else {
        // Fall back to whatever is already in the HTML (but ensure the prefix says Race).
        const existing = String(titleEl.textContent || '').trim();
        const parts = existing.split('•').map(s => s.trim()).filter(Boolean);
        const suffix = (parts.length > 1) ? parts.slice(1).join(' • ') : '';
        titleEl.textContent = suffix ? (raceLabel + ' • ' + suffix) : raceLabel;
      }
    }

    // Top 3 earners (points > 0)
    const top3 = (parsed && parsed.entries ? parsed.entries : [])
      .map(e => ({ driver: e.driver, points: getEventPointsValue(e, idx) }))
      .filter(r => r.points !== null && r.points > 0)
      .sort((a, b) => b.points - a.points)
      .slice(0, 3);

    const tbody = card.querySelector('tbody[data-role="race-top3"]');
    if(tbody){
      tbody.innerHTML = '';
      for(let r = 0; r < 3; r++){
        const row = document.createElement('tr');
        const entry = top3[r] || null;
        const driver = entry ? entry.driver : '-';
        const points = entry ? String(entry.points) : '-';
        row.innerHTML = '<td>' + (r + 1) + '</td><td>' + driver + '</td><td>' + points + '</td>';
        tbody.appendChild(row);
      }
    }

    const pdfLink = card.querySelector('a[data-role="race-pdf"]');
    if(pdfLink && !pdfLink._racePdfBound){
      pdfLink._racePdfBound = true;
      pdfLink.addEventListener('click', (e) => {
        e.preventDefault();
        try {
          generateRacePointsPdf({ parsed: window._points2025Parsed || parsed, eventIndex: idx });
        } catch (err) {
          // eslint-disable-next-line no-console
          console.warn('[pdf] failed to generate:', err);
          alert('Unable to generate PDF. ' + ((err && err.message) ? err.message : ''));
        }
      });
    }
  }
}

async function render2025PointsFromXlsx(){
  const host = document.getElementById('points-2025-table');
  const status = document.getElementById('points-2025-status');
  if(!host) return;

  const pointsSection = document.getElementById('points');
  const xlsxUrl =
    (window.__COTT__ && window.__COTT__.points2025XlsxUrl) ||
    (pointsSection && pointsSection.getAttribute('data-points-2025-xlsx')) ||
    'standings/2025/2025%20Clash%20Point%20Series%20Standings.xlsx';

  try {
    // If opened directly from disk, many browsers block/hang local fetch() calls.
    if (window.location && window.location.protocol === 'file:') {
      if(status) status.textContent = 'To load the 2025 table, open this site from a web server (not a file). Example: run "python -m http.server" in the project folder, then visit http://localhost:8000.';
      return;
    }

    if(typeof window.XLSX === 'undefined') throw new Error('XLSX library not loaded');

    if(status) status.textContent = 'Loading 2025 standings…';

    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeoutMs = 15000;
    const to = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;

    const res = await fetch(xlsxUrl, {
      cache: 'no-cache',
      signal: controller ? controller.signal : undefined
    });

    if(to) clearTimeout(to);
    if(!res.ok) throw new Error('Failed to fetch standings (' + res.status + ')');
    const buf = await res.arrayBuffer();

    const wb = window.XLSX.read(buf, { type: 'array' });
    const sheetName = (wb.SheetNames && wb.SheetNames[0]) ? wb.SheetNames[0] : null;
    if(!sheetName) throw new Error('No sheets found in workbook');

    const ws = wb.Sheets[sheetName];
    const rows = window.XLSX.utils.sheet_to_json(ws, { header: 1, defval: null });

    const parsed = parsePointsRows({
      rows,
      driverHeader: 'Racer Name',
      pointsHeader: 'Total Points'
    });
    if(!parsed) throw new Error('Could not locate "Racer Name" and "Total Points" columns');

    const view = buildPagedPointsView({ parsed, pageSize: 10 });
    if(!view) throw new Error('Could not build standings table');

    host.innerHTML = '';
    host.appendChild(view);
    if(status) status.remove();

    // Store for PDF generation handlers
    window._points2025Parsed = parsed;
    populatePastRaces2025Cards(parsed);
  } catch (err) {
    const msg = (err && err.message) ? err.message : String(err);
    if(status) status.textContent = 'Unable to load 2025 standings: ' + msg;
    // eslint-disable-next-line no-console
    console.warn('[points] 2025 standings load failed:', err);
  }
}

// Registration deadline countdown banner (flip clock)
function initRegistrationDeadlineCountdown(){
  const root = document.querySelector('[data-registration-deadline]');
  if(!root) return;

  function readIntAttr(name, fallback){
    const raw = String(root.getAttribute(name) || '').trim();
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  const month = readIntAttr('data-deadline-month', 3);
  const day = readIntAttr('data-deadline-day', 1);
  const hour = readIntAttr('data-deadline-hour', 0);
  const minute = readIntAttr('data-deadline-minute', 0);
  const second = readIntAttr('data-deadline-second', 0);

  function computeTarget(){
    const now = new Date();
    let t = new Date(now.getFullYear(), month - 1, day, hour, minute, second, 0);
    if(t.getTime() <= now.getTime()){
      t = new Date(now.getFullYear() + 1, month - 1, day, hour, minute, second, 0);
    }
    return t;
  }

  const target = computeTarget();
  root.setAttribute('data-deadline-target-iso', target.toISOString());

  function createDigitEl(initial){
    const el = document.createElement('div');
    el.className = 'flip-digit';
    el.dataset.value = String(initial || '0');

    const top = document.createElement('div');
    top.className = 'top';
    const topNum = document.createElement('span');
    topNum.className = 'num';
    topNum.textContent = el.dataset.value;
    top.appendChild(topNum);

    const bottom = document.createElement('div');
    bottom.className = 'bottom';
    const bottomNum = document.createElement('span');
    bottomNum.className = 'num';
    bottomNum.textContent = el.dataset.value;
    bottom.appendChild(bottomNum);

    el.appendChild(top);
    el.appendChild(bottom);
    return el;
  }

  function setDigitStatic(digitEl, next){
    const v = String(next);
    digitEl.dataset.value = v;
    const topNum = digitEl.querySelector('.top .num');
    const bottomNum = digitEl.querySelector('.bottom .num');
    if(topNum) topNum.textContent = v;
    if(bottomNum) bottomNum.textContent = v;
  }

  function animateFlip(digitEl, next){
    const nextVal = String(next);
    const cur = String(digitEl.dataset.value || '');
    if(cur === nextVal) return;

    // Respect reduced motion: just snap.
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){
      setDigitStatic(digitEl, nextVal);
      return;
    }

    const topNum = digitEl.querySelector('.top .num');
    const bottomNum = digitEl.querySelector('.bottom .num');
    if(!topNum || !bottomNum){
      setDigitStatic(digitEl, nextVal);
      return;
    }

    // Clean up any in-progress flip elements
    digitEl.querySelectorAll('.top-flip, .bottom-flip').forEach(n => n.remove());

    const topFlip = document.createElement('div');
    topFlip.className = 'top-flip';
    const topFlipNum = document.createElement('span');
    topFlipNum.className = 'num';
    topFlipNum.textContent = cur;
    topFlip.appendChild(topFlipNum);

    const bottomFlip = document.createElement('div');
    bottomFlip.className = 'bottom-flip';
    const bottomFlipNum = document.createElement('span');
    bottomFlipNum.className = 'num';
    bottomFlipNum.textContent = nextVal;
    bottomFlip.appendChild(bottomFlipNum);

    // Ensure base faces show current value prior to flip
    topNum.textContent = cur;
    bottomNum.textContent = cur;

    digitEl.appendChild(topFlip);
    digitEl.appendChild(bottomFlip);

    topFlip.addEventListener('animationend', () => {
      topFlip.remove();
      topNum.textContent = nextVal;
    }, { once: true });

    bottomFlip.addEventListener('animationend', () => {
      bottomFlip.remove();
      bottomNum.textContent = nextVal;
      digitEl.dataset.value = nextVal;
    }, { once: true });
  }

  function ensureDigits(container, count){
    if(!container) return [];
    const existing = Array.from(container.querySelectorAll('.flip-digit'));
    if(existing.length === count) return existing;

    container.innerHTML = '';
    const els = [];
    for(let i = 0; i < count; i++){
      const d = createDigitEl('0');
      container.appendChild(d);
      els.push(d);
    }
    return els;
  }

  const segs = {
    days: { digits: 2, els: [], mount: root.querySelector('[data-seg="days"] [data-digits]') },
    hours: { digits: 2, els: [], mount: root.querySelector('[data-seg="hours"] [data-digits]') },
    minutes: { digits: 2, els: [], mount: root.querySelector('[data-seg="minutes"] [data-digits]') },
    seconds: { digits: 2, els: [], mount: root.querySelector('[data-seg="seconds"] [data-digits]') },
  };

  Object.keys(segs).forEach(k => {
    segs[k].els = ensureDigits(segs[k].mount, segs[k].digits);
  });

  const a11y = root.querySelector('[data-deadline-a11y]');
  let lastAnnounceKey = '';

  function computeRemaining(){
    const nowMs = Date.now();
    const diffMs = Math.max(0, target.getTime() - nowMs);
    const totalSec = Math.floor(diffMs / 1000);
    const daysLeft = Math.floor(totalSec / 86400);
    const hoursLeft = Math.floor((totalSec % 86400) / 3600);
    const minutesLeft = Math.floor((totalSec % 3600) / 60);
    const secondsLeft = totalSec % 60;
    return { totalSec, daysLeft, hoursLeft, minutesLeft, secondsLeft };
  }

  function formatDigits(){
    const r = computeRemaining();
    const daysStr = String(r.daysLeft).padStart(segs.days.digits, '0');
    const hoursStr = String(r.hoursLeft).padStart(segs.hours.digits, '0');
    const minutesStr = String(r.minutesLeft).padStart(segs.minutes.digits, '0');
    const secondsStr = String(r.secondsLeft).padStart(segs.seconds.digits, '0');
    return { r, daysStr, hoursStr, minutesStr, secondsStr };
  }

  function setSeg(seg, str, animate){
    if(!seg || !Array.isArray(seg.els) || seg.els.length === 0) return;
    if(typeof str !== 'string') return;
    if(str.length !== seg.els.length){
      seg.els = ensureDigits(seg.mount, str.length);
    }
    for(let i = 0; i < seg.els.length; i++){
      const v = str[i];
      if(animate) animateFlip(seg.els[i], v);
      else setDigitStatic(seg.els[i], v);
    }
  }

  function announceIfNeeded(r){
    if(!a11y) return;
    // Announce once per minute (and on completion) to avoid spamming screen readers.
    const key = r.totalSec <= 0
      ? 'done'
      : (String(r.daysLeft) + ':' + String(r.hoursLeft) + ':' + String(r.minutesLeft));
    if(key === lastAnnounceKey) return;
    lastAnnounceKey = key;

    if(r.totalSec <= 0){
      a11y.textContent = 'Registration deadline reached.';
    } else {
      a11y.textContent =
        'Registration deadline in ' +
        r.daysLeft + ' days, ' +
        r.hoursLeft + ' hours, ' +
        r.minutesLeft + ' minutes.';
    }
  }

  // Initial paint (no animation)
  (function initialRender(){
    const { r, daysStr, hoursStr, minutesStr, secondsStr } = formatDigits();
    setSeg(segs.days, daysStr, false);
    setSeg(segs.hours, hoursStr, false);
    setSeg(segs.minutes, minutesStr, false);
    setSeg(segs.seconds, secondsStr, false);
    announceIfNeeded(r);
  })();

  // Tick
  let timer = null;
  function tick(){
    const { r, daysStr, hoursStr, minutesStr, secondsStr } = formatDigits();

    // Stop once complete (but keep banner visible at 00:00:00:00)
    if(r.totalSec <= 0){
      root.classList.add('deadline-ended');
      setSeg(segs.days, daysStr, true);
      setSeg(segs.hours, hoursStr, true);
      setSeg(segs.minutes, minutesStr, true);
      setSeg(segs.seconds, secondsStr, true);
      announceIfNeeded(r);
      if(timer) clearInterval(timer);
      timer = null;
      return;
    }

    setSeg(segs.days, daysStr, true);
    setSeg(segs.hours, hoursStr, true);
    setSeg(segs.minutes, minutesStr, true);
    setSeg(segs.seconds, secondsStr, true);
    announceIfNeeded(r);
  }

  // Align to second boundary for cleaner flip feel.
  const msToNextSecond = 1000 - (Date.now() % 1000);
  setTimeout(() => {
    tick();
    timer = setInterval(tick, 1000);
  }, msToNextSecond);
}

// Header: hide deadline banner on scroll down, show on scroll up
function initDeadlineBannerScrollHide(){
  const header = document.querySelector('header');
  const banner = document.querySelector('.deadline-banner[data-registration-deadline]');
  if(!header || !banner) return;

  let lastY = (typeof window.scrollY === 'number') ? window.scrollY : 0;
  let ticking = false;
  let hidden = false;
  let cooldownUntil = 0;
  const minDelta = 10;   // ignore tiny scroll jitters
  const showAtTopY = 16; // always show near very top
  const cooldownMs = 240; // prevent oscillation when layout shifts

  function applyHidden(hidden){
    header.classList.toggle('deadline-hidden', hidden);
    if(hidden) banner.setAttribute('aria-hidden', 'true');
    else banner.removeAttribute('aria-hidden');
  }

  function setHidden(nextHidden){
    if(nextHidden === hidden) return;
    hidden = nextHidden;
    applyHidden(hidden);

    // Collapsing/expanding inside a sticky header can shift layout, which can
    // flip perceived scroll direction and cause rapid toggling. A short cooldown
    // plus resyncing lastY after the layout settles prevents the bounce-loop.
    cooldownUntil = Date.now() + cooldownMs;
    requestAnimationFrame(() => {
      lastY = (typeof window.scrollY === 'number') ? window.scrollY : lastY;
    });
  }

  // Ensure correct initial state
  hidden = false;
  applyHidden(false);

  function onScroll(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;

      const y = (typeof window.scrollY === 'number') ? window.scrollY : 0;
      const now = Date.now();
      const freezeUntil = (typeof window.__deadlineBannerFreezeUntil === 'number')
        ? window.__deadlineBannerFreezeUntil
        : 0;

      // During smooth anchor scrolling (and right after a hide/show), ignore
      // scroll deltas to avoid oscillation.
      if(now < cooldownUntil || now < freezeUntil){
        lastY = y;
        return;
      }

      // Keep banner visible when the mobile menu is open.
      if(header.classList.contains('nav-open')){
        lastY = y;
        setHidden(false);
        return;
      }

      if(y <= showAtTopY){
        lastY = y;
        setHidden(false);
        return;
      }

      const dy = y - lastY;
      if(Math.abs(dy) < minDelta){
        lastY = y;
        return;
      }

      if(dy > 0) setHidden(true);  // scrolling down
      else setHidden(false);       // scrolling up

      lastY = y;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
}

// Mobile nav toggle (hamburger)
function initMobileNav(){
  const header = document.querySelector('header');
  const toggle = document.querySelector('.nav-toggle');
  const menu = document.getElementById('primary-nav');
  if(!header || !toggle || !menu) return;

  const setOpen = (open) => {
    if(open) document.dispatchEvent(new CustomEvent('mini-cart:close'));
    header.classList.toggle('nav-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  const isOpen = () => header.classList.contains('nav-open');
  const close = () => setOpen(false);

  toggle.addEventListener('click', () => setOpen(!isOpen()));

  // Close when clicking outside the header/menu
  document.addEventListener('click', (e) => {
    if(!isOpen()) return;
    if(e.target.closest('header')) return;
    close();
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape') close();
  });

  // Close on menu item click (works for index anchors and normal links)
  menu.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if(link) close();
  });

  // If we leave mobile breakpoint, ensure menu is closed
  const mq = window.matchMedia('(min-width: 1181px)');
  const handle = () => { if(mq.matches) close(); };
  if(typeof mq.addEventListener === 'function') mq.addEventListener('change', handle);
  else if(typeof mq.addListener === 'function') mq.addListener(handle);
}

// Mobile: collapsible sections (accordion-style)
function initMobileCollapsibleSections(){
  const mq = window.matchMedia('(max-width: 720px)');

  function ensureStructure(){
    const sections = Array.from(document.querySelectorAll('section[id]:not(.hero)'));

    for(const section of sections){
      if(section.dataset.collapsibleReady === 'true') continue;

      const id = section.id;
      const container = section.querySelector(':scope > .container') || section;

      // Prefer the top heading of the section.
      const heading = container.querySelector(':scope > h2, :scope > h1, :scope > h3');
      if(!heading) continue;

      // Build header row (heading + toggle button)
      const headerRow = document.createElement('div');
      headerRow.className = 'section-collapsible-header';

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'section-collapsible-toggle';
      toggle.setAttribute('aria-label', 'Toggle ' + (heading.textContent || 'section'));

      const body = document.createElement('div');
      body.className = 'section-collapsible-body';
      const bodyId = 'section-body-' + id;
      body.id = bodyId;

      toggle.setAttribute('aria-controls', bodyId);

      // Move everything after the heading into the body wrapper.
      const start = heading.nextSibling;
      let node = start;
      while(node){
        const next = node.nextSibling;
        body.appendChild(node);
        node = next;
      }

      // Replace heading with header row containing heading + toggle.
      headerRow.appendChild(heading);
      headerRow.appendChild(toggle);

      container.insertBefore(headerRow, container.firstChild);
      container.insertBefore(body, headerRow.nextSibling);

      section.classList.add('section-collapsible');
      section.dataset.collapsibleReady = 'true';

      toggle.addEventListener('click', () => {
        const expanded = section.getAttribute('data-expanded') === 'true';
        setExpanded(section, !expanded);
      });
    }
  }

  function setExpanded(section, expanded){
    section.setAttribute('data-expanded', expanded ? 'true' : 'false');
    const btn = section.querySelector(':scope .section-collapsible-toggle');
    if(btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function applyStateForBreakpoint(){
    ensureStructure();

    const sections = Array.from(document.querySelectorAll('section.section-collapsible[id]:not(.hero)'));
    if(!mq.matches){
      // Desktop/tablet: always expanded (but keep structure; CSS hides toggle)
      sections.forEach(s => setExpanded(s, true));
      return;
    }

    // Mobile: collapse everything except Classes.
    for(const s of sections){
      const shouldExpand = (s.id === 'classes');
      setExpanded(s, shouldExpand);
    }
  }

  // Expand a section by id (mobile only), then return it.
  function expandIfCollapsible(targetId){
    if(!targetId) return null;
    const el = document.getElementById(targetId);
    if(!el) return null;
    if(!mq.matches) return el;
    if(el.matches && el.matches('section.section-collapsible')) setExpanded(el, true);
    return el;
  }

  // Expose for anchor scroll logic
  window.__expandCollapsibleSection = expandIfCollapsible;

  applyStateForBreakpoint();

  const handle = () => applyStateForBreakpoint();
  if(typeof mq.addEventListener === 'function') mq.addEventListener('change', handle);
  else if(typeof mq.addListener === 'function') mq.addListener(handle);
}

// Past Races: scrollable photo galleries + lightbox
function initPastRacesPhotoGalleries(){
  const galleryEls = Array.from(document.querySelectorAll('.thumb-gallery[data-manifest]'));
  if(galleryEls.length === 0) return;

  const lightboxEl = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxCaption = document.getElementById('lightbox-caption');
  const lightboxOpen = document.getElementById('lightbox-open');
  if(!lightboxEl || !lightboxImg || !lightboxCaption || !lightboxOpen) return;

  const active = {
    photos: [],
    index: 0,
    title: '',
    lastFocus: null,
  };

  function resolvePhotoUrl(p){
    const base = (window.__COTT__ && window.__COTT__.photoBaseUrl) ? String(window.__COTT__.photoBaseUrl) : '';
    const raw = String(p || '').trim();
    if(!raw) return raw;
    if(/^https?:\/\//i.test(raw)) return raw;
    if(!base) return raw;
    const cleanBase = base.replace(/\/+$/, '');
    const cleanPath = raw.replace(/^\/+/, '');
    return cleanBase + '/' + cleanPath;
  }

  function setLightboxOpen(isOpen){
    if(isOpen){
      lightboxEl.hidden = false;
      active.lastFocus = document.activeElement;
      document.body.style.overflow = 'hidden';
      lightboxEl.setAttribute('aria-hidden', 'false');
    }else{
      lightboxEl.hidden = true;
      document.body.style.overflow = '';
      lightboxEl.setAttribute('aria-hidden', 'true');
      if(active.lastFocus && typeof active.lastFocus.focus === 'function') active.lastFocus.focus();
      active.lastFocus = null;
    }
  }

  function showAt(nextIndex){
    if(!Array.isArray(active.photos) || active.photos.length === 0) return;
    const len = active.photos.length;
    const i = ((nextIndex % len) + len) % len;
    active.index = i;
    const src = encodeURI(resolvePhotoUrl(active.photos[i]));
    const abs = (typeof URL !== 'undefined') ? (new URL(src, window.location.href)).toString() : src;
    lightboxImg.src = src;
    lightboxImg.alt = active.title ? (active.title + ' photo ' + (i + 1)) : ('Photo ' + (i + 1));
    lightboxCaption.textContent = (active.title ? (active.title + ' • ') : '') + (i + 1) + ' / ' + len;
    lightboxOpen.href = abs;
    lightboxOpen.setAttribute('href', abs);
  }

  function openLightbox({ photos, index, title }){
    active.photos = Array.isArray(photos) ? photos : [];
    active.title = String(title || '').trim();
    setLightboxOpen(true);
    showAt(Number.isFinite(index) ? index : 0);
  }

  function closeLightbox(){
    setLightboxOpen(false);
  }

  function next(){ showAt(active.index + 1); }
  function prev(){ showAt(active.index - 1); }

  lightboxEl.addEventListener('click', e => {
    const btn = e.target.closest('[data-action]');
    const action = btn ? btn.getAttribute('data-action') : null;
    if(action === 'close') closeLightbox();
    else if(action === 'next') next();
    else if(action === 'prev') prev();
  });

  document.addEventListener('keydown', e => {
    if(lightboxEl.hidden) return;
    if(e.key === 'Escape'){ e.preventDefault(); closeLightbox(); }
    else if(e.key === 'ArrowRight'){ e.preventDefault(); next(); }
    else if(e.key === 'ArrowLeft'){ e.preventDefault(); prev(); }
  });

  function computeScrollStep(track){
    const first = track.querySelector('.thumb');
    const thumbW = first ? first.getBoundingClientRect().width : 150;
    const gap = parseFloat(getComputedStyle(track).gap || '0') || 0;
    return Math.round((thumbW + gap) * 4);
  }

  async function hydrateGallery(galleryEl){
    const manifestUrl = galleryEl.getAttribute('data-manifest');
    const videoHref = galleryEl.getAttribute('data-video-href');
    const videoThumb = galleryEl.getAttribute('data-video-thumb');
    const track = galleryEl.querySelector('.gallery-track');
    const btnPrev = galleryEl.querySelector('.gallery-nav.prev');
    const btnNext = galleryEl.querySelector('.gallery-nav.next');
    if(!manifestUrl || !track) return;

    // Visible state so we can tell if hydration is running.
    galleryEl.dataset.galleryState = 'loading';
    track.innerHTML = '<div class="muted" style="padding:10px 2px;">Loading photos…</div>';

    try{
      const res = await fetch(manifestUrl, { cache: 'no-store' });
      if(!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      const photos = Array.isArray(data?.photos) ? data.photos : [];
      const title = String(data?.round || '').trim() || 'Photos';

      const frag = document.createDocumentFragment();

      // Optional video thumb (included in the same scrollable gallery)
      if(videoHref && videoThumb){
        const a = document.createElement('a');
        a.className = 'thumb thumb-video';
        a.href = videoHref;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.setAttribute('aria-label', 'Watch ' + title + ' highlight video');

        const img = document.createElement('img');
        img.className = 'thumb-img';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = title + ' video thumbnail';
        img.src = videoThumb;

        const badge = document.createElement('span');
        badge.className = 'thumb-badge';
        badge.textContent = 'Video';

        a.appendChild(img);
        a.appendChild(badge);
        frag.appendChild(a);
      }

      for(let i = 0; i < photos.length; i++){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'thumb thumb-photo';
        btn.setAttribute('aria-label', 'Open ' + title + ' photo ' + (i + 1) + ' of ' + photos.length);
        btn.dataset.index = String(i);

        const img = document.createElement('img');
        img.className = 'thumb-img';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.draggable = false;
        img.alt = title + ' thumbnail ' + (i + 1);
        // Encode spaces and other safe URL chars, but keep it relative.
        img.src = encodeURI(resolvePhotoUrl(photos[i]));

        const badge = document.createElement('span');
        badge.className = 'thumb-badge';
        badge.textContent = 'Photo';

        btn.appendChild(img);
        btn.appendChild(badge);
        frag.appendChild(btn);
      }

      track.innerHTML = '';
      track.appendChild(frag);
      galleryEl.dataset.galleryState = 'ready';

      track.addEventListener('click', e => {
        const btn = e.target.closest('button.thumb-photo');
        if(!btn) return;
        const idx = Number(btn.dataset.index || 0);
        openLightbox({ photos, index: idx, title });
      });

      const step = () => computeScrollStep(track);
      if(btnPrev){
        btnPrev.addEventListener('click', () => {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if(btnNext){
        btnNext.addEventListener('click', () => {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    }catch(err){
      // Keep layout stable but show a useful hint.
      track.innerHTML = '<div class="muted" style="padding:10px 2px;">Photos unavailable (check server console for 404s).</div>';
      galleryEl.dataset.galleryState = 'error';
    }
  }

  galleryEls.forEach(el => { hydrateGallery(el); });
}

// Racer/Vendor: General Admission link (optionally derived from ?event=round-x)
function initRacerVendorGeneralAdmissionLink(){
  const gaLink = document.getElementById('ga-pass-link');
  if(!gaLink) return;

  let url;
  try{
    url = new URL(window.location.href);
  }catch(_e){
    return;
  }

  const event = (url.searchParams.get('event') || '').trim().toLowerCase();

  const byEvent = {
    'round-1': (gaLink.dataset && gaLink.dataset.gaRound1Href) ? String(gaLink.dataset.gaRound1Href) : '',
    'round-4': (gaLink.dataset && gaLink.dataset.gaRound4Href) ? String(gaLink.dataset.gaRound4Href) : '',
    'round-6': (gaLink.dataset && gaLink.dataset.gaRound6Href) ? String(gaLink.dataset.gaRound6Href) : '',
  };

  const fallback = (gaLink.dataset && gaLink.dataset.gaDefaultHref) ? String(gaLink.dataset.gaDefaultHref) : (gaLink.getAttribute('href') || '');
  const href = (byEvent[event] || '').trim() || fallback.trim();
  if(href) gaLink.setAttribute('href', href);
}

// Buy Tickets: slide-out jump menu (mobile) + sticky sidebar (desktop)
function initTicketsJumpMenu(){
  const root = document.querySelector('.tickets-jump');
  if(!root) return;

  const toggle = root.querySelector('.tickets-jump-toggle');
  const panel = root.querySelector('#tickets-jump-panel');
  if(!toggle || !panel) return;

  function isOpen(){
    return String(root.getAttribute('data-open') || '') === 'true';
  }

  function setOpen(open){
    root.setAttribute('data-open', open ? 'true' : 'false');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Ensure consistent initial state (important if page is cached)
  setOpen(false);

  toggle.addEventListener('click', () => {
    setOpen(!isOpen());
  });

  // Close after jumping
  panel.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if(!a) return;
    setTimeout(() => setOpen(false), 0);
  });

  // Close on hash change (e.g., back/forward)
  window.addEventListener('hashchange', () => setOpen(false));

  // Close on escape
  window.addEventListener('keydown', (e) => {
    if(e.key === 'Escape') setOpen(false);
  });

  // Click-away close (mobile drawer feel)
  document.addEventListener('click', (e) => {
    if(!isOpen()) return;
    if(root.contains(e.target)) return;
    setOpen(false);
  });
}

// External links: always open in a new tab (safely)
function initExternalLinksNewTab(){
  function ensureRelTokens(a){
    const tokens = String(a.getAttribute('rel') || '')
      .split(/\s+/)
      .map(s => s.trim())
      .filter(Boolean);

    if(!tokens.includes('noopener')) tokens.push('noopener');
    if(!tokens.includes('noreferrer')) tokens.push('noreferrer');
    a.setAttribute('rel', tokens.join(' '));
  }

  function shouldHandleAnchor(a){
    if(!a || a.tagName !== 'A') return false;
    if(a.hasAttribute('download')) return false;

    const href = (a.getAttribute('href') || '').trim();
    if(!href) return false;

    // Skip in-page anchors + special schemes
    const lower = href.toLowerCase();
    if(lower.startsWith('#')) return false;
    if(lower.startsWith('mailto:')) return false;
    if(lower.startsWith('tel:')) return false;
    if(lower.startsWith('javascript:')) return false;

    // Only treat absolute http(s) links as "external"
    let url;
    try{
      url = new URL(href, window.location.href);
    }catch(_e){
      return false;
    }
    if(url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    // If we can compare origins, do it. If opened as file://, treat all http(s) as external.
    const origin = (window.location && typeof window.location.origin === 'string') ? window.location.origin : '';
    if(origin && origin !== 'null'){
      return url.origin !== origin;
    }
    return true;
  }

  function apply(root){
    const anchors = (root && root.querySelectorAll)
      ? Array.from(root.querySelectorAll('a[href]'))
      : [];

    for(const a of anchors){
      // If author already set target, only ensure rel safety on _blank.
      const existingTarget = (a.getAttribute('target') || '').trim();
      if(existingTarget){
        if(existingTarget === '_blank') ensureRelTokens(a);
        continue;
      }

      if(!shouldHandleAnchor(a)) continue;

      a.setAttribute('target', '_blank');
      ensureRelTokens(a);
    }
  }

  // Initial pass
  apply(document);

  // Cover any dynamically inserted content (e.g., injected cards/links)
  if(typeof MutationObserver === 'undefined') return;
  const body = document.body;
  if(!body) return;

  const observer = new MutationObserver((mutations) => {
    for(const m of mutations){
      if(m.type !== 'childList') continue;
      for(const node of m.addedNodes){
        if(!node) continue;
        if(node.nodeType !== 1) continue; // ELEMENT_NODE
        if(node.tagName === 'A') apply(node.parentElement || document);
        else apply(node);
      }
    }
  });

  observer.observe(body, { childList: true, subtree: true });
}

// Cart: quantity +/- and remove, auto-refresh (no Update button)
function initCartAutoUpdate(){
  const section = document.querySelector('[data-cart-section][data-cart-section-id]');
  const form = section ? section.querySelector('form[data-cart-form]') : null;
  if(!section || !form) return;

  let inFlight = false;
  const sectionId = String(section.getAttribute('data-cart-section-id') || '').trim() || 'main';
  const sectionHandle = String(section.getAttribute('data-cart-section-handle') || '').trim() || 'main-cart';
  const debug = (String(section.getAttribute('data-cart-debug') || '').trim() === 'true');

  function log(){
    if(!debug) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, arguments);
  }

  async function parseResponseBody(res){
    const ct = String(res.headers.get('content-type') || '');
    try{
      if(ct.includes('application/json')) return await res.json();
      return await res.text();
    }catch(_e){
      return null;
    }
  }

  function extractShopifyErrorMessage(body){
    if(!body) return '';
    if(typeof body === 'string') return body.slice(0, 180);
    if(body && typeof body.description === 'string') return body.description;
    if(body && typeof body.message === 'string') return body.message;
    if(body && typeof body.error === 'string') return body.error;
    // Some Shopify errors come back as { errors: "..." } or { errors: { qty: ["..."] } }
    if(body && typeof body.errors === 'string') return body.errors;
    if(body && body.errors && typeof body.errors === 'object'){
      try{
        const firstKey = Object.keys(body.errors)[0];
        const v = body.errors[firstKey];
        if(Array.isArray(v) && v[0]) return String(v[0]);
        if(typeof v === 'string') return v;
      }catch(_e){ /* ignore */ }
    }
    return '';
  }

  function setBusy(busy){
    section.setAttribute('aria-busy', busy ? 'true' : 'false');
    const controls = Array.from(section.querySelectorAll('button, input'));
    for(const el of controls){
      // Don't block checkout, but do block other cart controls during updates.
      if(el && el.matches && el.matches('button[name="checkout"]')) continue;
      if('disabled' in el) el.disabled = !!busy;
    }
  }

  async function refreshCartSection(){
    // Use Shopify's section endpoint (more reliable than ?sections= JSON on some setups)
    const u = new URL(window.location.href);
    u.searchParams.delete('sections');
    u.searchParams.set('section_id', sectionHandle);

    const res = await fetch(u.toString(), {
      headers: { 'Accept': 'text/html' },
      cache: 'no-store',
      credentials: 'same-origin'
    });
    const html = await res.text();
    if(!res.ok){
      const msg = extractShopifyErrorMessage(html) || ('Cart refresh failed (' + res.status + ')');
      throw new Error(msg);
    }
    if(!html || !html.trim()){
      throw new Error('Cart refresh returned no HTML');
    }

    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const newSection =
      tmp.querySelector('section.cart[data-cart-section]') ||
      tmp.querySelector('.cart[data-cart-section]') ||
      tmp.querySelector('section.cart');
    if(!newSection){
      log('[cart] refresh HTML:', html);
      throw new Error('Cart refresh returned no cart section');
    }

    section.replaceWith(newSection);
    initCartAutoUpdate(); // re-bind listeners on the new DOM
  }

  async function changeLineQuantity({ line, quantity }){
    if(inFlight) return;
    if(!Number.isFinite(line)) return;
    if(!Number.isFinite(quantity) || quantity < 0) return;

    inFlight = true;
    setBusy(true);
    try{
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ line, quantity })
      });
      const data = await parseResponseBody(res);
      if(!res.ok){
        const msg = extractShopifyErrorMessage(data) || ('Cart update failed (' + res.status + ')');
        throw new Error(msg);
      }
      log('[cart] change ok:', data);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      await refreshCartSection();
    }catch(err){
      // eslint-disable-next-line no-console
      console.warn('[cart] update failed:', err);
      alert('Unable to update cart: ' + ((err && err.message) ? err.message : 'Please try again.'));
      setBusy(false);
    }finally{
      inFlight = false;
    }
  }

  function getLineFromTarget(target){
    const row = target && target.closest ? target.closest('tr[data-cart-line]') : null;
    const raw = row ? row.getAttribute('data-cart-line') : '';
    const line = parseInt(raw || '', 10);
    return Number.isFinite(line) ? line : null;
  }

  function getKeyFromTarget(target){
    const row = target && target.closest ? target.closest('tr[data-cart-line]') : null;
    const key = row ? String(row.getAttribute('data-cart-key') || '').trim() : '';
    return key || null;
  }

  async function changeItemQuantity({ key, line, quantity }){
    if(inFlight) return;
    if(!Number.isFinite(quantity) || quantity < 0) return;

    inFlight = true;
    setBusy(true);
    try{
      const payload = { quantity };
      if(key) payload.id = key;
      else payload.line = line;

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await parseResponseBody(res);
      if(!res.ok){
        const msg = extractShopifyErrorMessage(data) || ('Cart update failed (' + res.status + ')');
        throw new Error(msg);
      }
      log('[cart] change ok:', data);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      await refreshCartSection();
    }catch(err){
      // eslint-disable-next-line no-console
      console.warn('[cart] update failed:', err);
      alert('Unable to update cart: ' + ((err && err.message) ? err.message : 'Please try again.'));
      setBusy(false);
    }finally{
      inFlight = false;
    }
  }

  function getQtyInputFromRowTarget(target){
    const row = target && target.closest ? target.closest('tr[data-cart-line]') : null;
    if(!row) return null;
    return row.querySelector('input[data-cart-qty-input]') || null;
  }

  // Prevent Enter in qty inputs from submitting the form.
  section.addEventListener('keydown', (e) => {
    const t = e.target;
    if(!t || !t.matches) return;
    if(!t.matches('input[data-cart-qty-input]')) return;
    if(e.key === 'Enter'){
      e.preventDefault();
      t.blur();
    }
  });

  section.addEventListener('click', (e) => {
    const btnQty = e.target.closest('[data-cart-qty]');
    if(btnQty){
      const line = getLineFromTarget(btnQty);
      const key = getKeyFromTarget(btnQty);
      const input = getQtyInputFromRowTarget(btnQty);
      if(line === null || !input) return;

      const current = parseInt(String(input.value || '0'), 10);
      const curQty = Number.isFinite(current) ? current : 0;
      const dir = String(btnQty.getAttribute('data-cart-qty') || '').toLowerCase();
      const next = (dir === 'increase') ? (curQty + 1) : (curQty - 1);
      const qty = Math.max(0, next);

      input.value = String(qty);
      changeItemQuantity({ key, line, quantity: qty });
      return;
    }

    const btnRemove = e.target.closest('[data-cart-remove]');
    if(btnRemove){
      const line = getLineFromTarget(btnRemove);
      if(line === null) return;
      const key = getKeyFromTarget(btnRemove);
      changeItemQuantity({ key, line, quantity: 0 });
    }
  });

  // Debounced manual qty edits
  let qtyTimer = null;
  section.addEventListener('input', (e) => {
    const input = e.target;
    if(!input || !input.matches || !input.matches('input[data-cart-qty-input]')) return;
    const line = getLineFromTarget(input);
    const key = getKeyFromTarget(input);
    if(line === null) return;

    if(qtyTimer) clearTimeout(qtyTimer);
    qtyTimer = setTimeout(() => {
      qtyTimer = null;
      const raw = parseInt(String(input.value || '0'), 10);
      const qty = Number.isFinite(raw) ? Math.max(0, raw) : 0;
      input.value = String(qty);
      changeItemQuantity({ key, line, quantity: qty });
    }, 450);
  });
}

// Race Series Cart Builder (interactive questionnaire)
function initRaceSeriesCartBuilder(){
  let roots = Array.from(document.querySelectorAll('[data-rb]'));
  if(roots.length === 0){
    // Fallback: build roots from debug elements (in case attribute parsing/markup differs)
    const dbgEls = Array.from(document.querySelectorAll('[data-rb-debug]'));
    roots = dbgEls
      .map(el => el.closest ? (el.closest('[data-rb]') || el.closest('section.rb') || el.closest('section')) : null)
      .filter(Boolean);
  }

  if(roots.length === 0) return;

  roots.forEach(root => {
    const debugEl = root.querySelector('[data-rb-debug]');
    if(debugEl) debugEl.textContent = 'Builder JS loaded.';

    const progressBar = root.querySelector('[data-rb-progress-bar]');
    const steps = Array.from(root.querySelectorAll('[data-rb-step]'));
    const byId = new Map(steps.map(el => [el.getAttribute('data-rb-step'), el]));
    const reviewList = root.querySelector('[data-rb-review-list]');
    const pointsList = root.querySelector('[data-rb-points-list]');
    const statusEl = root.querySelector('[data-rb-status]');

    function escapeHtml(s){
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    const gaTitle = root.dataset && root.dataset.rbGaTitle ? root.dataset.rbGaTitle : 'General Admission';
    let gaVariants = [];
    try{
      const el = root.querySelector('[data-rb-ga-variants]');
      if(el) gaVariants = JSON.parse(el.textContent || '[]') || [];
    }catch(_e){ gaVariants = []; }

    function pickGeneralAdmissionVariant(){
      const variants = (gaVariants || []).filter(v => v && v.id);
      if(variants.length === 0) return null;
      const configuredWeekendId = Number(root.dataset && root.dataset.rbGaWeekendVariantId ? root.dataset.rbGaWeekendVariantId : 0);
      const byConfiguredWeekend = configuredWeekendId ? variants.find(v => Number(v.id) === configuredWeekendId) : null;
      const byWeekend = variants.find(v => String(v.title || '').toLowerCase().includes('weekend'));
      const chosen = byConfiguredWeekend || byWeekend || variants[0];
      const vTitle = String(chosen.title || '').trim();
      const title = vTitle && vTitle.toLowerCase() !== 'default title' ? `${gaTitle} — ${vTitle}` : gaTitle;
      return { id: Number(chosen.id), title };
    }

    const state = {
      role: null,
      racer: {
        wantsPoints: null,
        generalAdmission: null,
        crewGeneralAdmission: null,
        crewCount: 0,
        autoPoints: null
      }
    };

    function clearManualPointsPick(){
      if(pointsList) pointsList.innerHTML = '';
      root.querySelectorAll('input[name="rb_points_pick"]').forEach(el => { el.checked = false; });
    }

    const flows = {
      spectator: ['role','spectator_pass','spectator_golf_cart','pit_side_parking','rv_parking','review'],
      racer: ['role','racer_crew','racer_classes','racer_points_q','racer_points_pick','racer_private_testing','racer_vip_parking','pit_side_parking','rv_parking','review']
    };
    let currentFlow = flows.spectator;
    let currentIdx = 0;

    function visibleStepIds(){
      if(state.role !== 'racer') return currentFlow;
      if(state.racer.wantsPoints !== 'yes') return currentFlow.filter(id => id !== 'racer_points_pick');

      // Only show the points picker if multiple classes are selected.
      const classCount = getCheckedCheckboxes('rb_class_entry').length;
      if(classCount <= 1) return currentFlow.filter(id => id !== 'racer_points_pick');

      if(!hasAnyPointsOption()) return currentFlow.filter(id => id !== 'racer_points_pick');
      return currentFlow;
    }

    function show(stepId){
      steps.forEach(el => { el.hidden = true; });
      const el = byId.get(stepId);
      if(!el) return;
      el.hidden = false;
      clearStepErrors();

      const ids = visibleStepIds();
      const idx = Math.max(0, ids.indexOf(stepId));
      const pct = ids.length <= 1 ? 0 : Math.round((idx / (ids.length - 1)) * 100);
      if(progressBar) progressBar.style.width = pct + '%';

      if(stepId === 'racer_points_pick') buildPointsPick();
      if(stepId === 'review') buildReview();
    }

    function clearStepErrors(){
      steps.forEach(el => {
        const err = el.querySelector('[data-rb-error]');
        if(err) err.hidden = true;
      });
    }
    function stepError(stepId, message){
      const el = byId.get(stepId);
      if(!el) return;
      const err = el.querySelector('[data-rb-error]');
      if(!err) return;
      err.textContent = message || 'Please check this step.';
      err.hidden = false;
    }

    function getCheckedRadio(name){
      return root.querySelector(`input[type=\"radio\"][name=\"${name}\"]:checked`);
    }
    function getCheckedCheckboxes(name){
      return Array.from(root.querySelectorAll(`input[type=\"checkbox\"][name=\"${name}\"]:checked`));
    }
    function parseVariantChoice(inputEl){
      if(!inputEl) return null;
      const id = inputEl.getAttribute('data-variant-id') || inputEl.value;
      const title = inputEl.getAttribute('data-title') || '';
      if(!id) return null;
      return { id: Number(id), title };
    }

    function getSelectedClassPointsOptions(){
      return getCheckedCheckboxes('rb_class_entry')
        .map(el => {
          const pointsVariantId = String(el.getAttribute('data-points-variant-id') || '').trim();
          const pointsTitle = String(el.getAttribute('data-points-title') || '').trim();
          const pointsPrice = String(el.getAttribute('data-points-price') || '').trim();
          const classTitle = String(el.getAttribute('data-title') || '').trim();
          if(!pointsVariantId || !pointsTitle) return null;
          return {
            id: Number(pointsVariantId),
            title: pointsTitle,
            price: pointsPrice,
            classTitle
          };
        })
        .filter(Boolean);
    }

    function hasAnyPointsOption(){
      return getSelectedClassPointsOptions().length > 0;
    }

    function buildPointsPick(){
      if(!pointsList) return;
      pointsList.innerHTML = '';
      const rows = getSelectedClassPointsOptions().map(r => ({
        pointsVariantId: r.id,
        pointsTitle: r.title,
        pointsPrice: r.price,
        classTitle: r.classTitle
      }));

      if(rows.length === 0){
        pointsList.innerHTML = '<p class=\"muted\" style=\"margin:0\">No points options configured for selected class(es).</p>';
        return;
      }
      const frag = document.createDocumentFragment();
      rows.forEach(row => {
        const label = document.createElement('label');
        label.className = 'rb-choice';
        label.setAttribute('data-rb-selectable','true');
        label.innerHTML =
          `<input class=\"rb-input\" type=\"checkbox\" name=\"rb_points_pick\" value=\"${row.pointsVariantId}\" data-title=\"${escapeHtml(row.pointsTitle)}\" checked />` +
          `<span class=\"rb-choice-main\">` +
          `<span class=\"rb-choice-title\">${escapeHtml(row.pointsTitle)} <span class=\"muted\" style=\"font-weight:400\">— ${escapeHtml(row.classTitle)}</span></span>` +
          `<span class=\"rb-choice-price\">${escapeHtml(row.pointsPrice || '')}</span>` +
          `</span>`;
        frag.appendChild(label);
      });
      pointsList.appendChild(frag);
      bindAllSelectables(pointsList);
    }

    function buildReview(){
      if(!reviewList) return;
      reviewList.innerHTML = '';
      const items = getPlannedItems();
      if(items.length === 0){
        reviewList.innerHTML = '<p class=\"muted\" style=\"margin:0\">No items selected.</p>';
        return;
      }
      const ul = document.createElement('ul');
      ul.className = 'muted';
      ul.style.margin = '0';
      ul.style.paddingLeft = '18px';
      items.forEach(item => {
        const li = document.createElement('li');
        const qty = item.quantity && item.quantity > 1 ? ` (x${item.quantity})` : '';
        li.textContent = (item.title || `Variant ${item.id}`) + qty;
        ul.appendChild(li);
      });
      reviewList.appendChild(ul);
    }

    function getPlannedItems(){
      const planned = [];

      if(state.role === 'racer' && state.racer.generalAdmission) planned.push({ ...state.racer.generalAdmission, quantity: 1 });
      if(state.role === 'racer' && state.racer.crewGeneralAdmission && state.racer.crewGeneralAdmission.quantity > 0){
        planned.push(state.racer.crewGeneralAdmission);
      }
      if(state.role === 'racer' && state.racer.autoPoints) planned.push(state.racer.autoPoints);

      if(state.role === 'spectator'){
        const pass = parseVariantChoice(getCheckedRadio('rb_spectator_pass'));
        if(pass) planned.push(pass);
        const golf = getCheckedRadio('rb_golf');
        if(golf && golf.value === 'yes'){
          const v = parseVariantChoice(golf);
          if(v) planned.push(v);
        }
      }

      if(state.role === 'racer'){
        getCheckedCheckboxes('rb_class_entry').forEach(el => {
          const id = Number(el.value);
          const title = String(el.getAttribute('data-title') || '').trim();
          if(id) planned.push({ id, title });
        });
        getCheckedCheckboxes('rb_tech_card').forEach(el => {
          const id = Number(el.value);
          const title = String(el.getAttribute('data-title') || '').trim();
          if(id) planned.push({ id, title });
        });
        // Only add manual points picks when multiple classes are selected.
        if(getCheckedCheckboxes('rb_class_entry').length > 1){
          getCheckedCheckboxes('rb_points_pick').forEach(el => {
            const id = Number(el.value);
            const title = String(el.getAttribute('data-title') || '').trim();
            if(id) planned.push({ id, title });
          });
        }
        const priv = getCheckedRadio('rb_private_testing');
        if(priv && priv.value === 'yes'){
          const v = parseVariantChoice(priv);
          if(v) planned.push(v);
        }
        const vip = getCheckedRadio('rb_vip_racer_parking');
        if(vip && vip.value === 'yes'){
          const v = parseVariantChoice(vip);
          if(v) planned.push(v);
        }
      }

      // shared steps
      const pit = getCheckedRadio('rb_pit_parking');
      if(pit && pit.value === 'yes'){
        const v = parseVariantChoice(pit);
        if(v) planned.push(v);
      }
      const rv = getCheckedRadio('rb_rv');
      if(rv && rv.value === 'yes'){
        const v = parseVariantChoice(rv);
        if(v) planned.push(v);
      }

      // Do NOT dedupe here (driver GA + crew GA can be the same variant id).
      // We'll merge quantities when adding to cart.
      return planned.filter(it => it && it.id);
    }

    function validateAndCapture(stepId){
      if(stepId === 'role'){
        const role = getCheckedRadio('rb_role');
        if(!role) return { ok:false, error:'Please choose Racer or Spectator to continue.' };
        state.role = role.value;
        currentFlow = (state.role === 'racer') ? flows.racer : flows.spectator;
        currentIdx = 0;
        state.racer.generalAdmission = (state.role === 'racer') ? pickGeneralAdmissionVariant() : null;
        state.racer.crewGeneralAdmission = null;
        state.racer.crewCount = 0;
        // Clear crew radio selection if present
        root.querySelectorAll('input[name="rb_crew"]').forEach(el => { el.checked = false; });
        state.racer.autoPoints = null;
        return { ok:true };
      }
      if(stepId === 'racer_crew'){
        const crew = getCheckedRadio('rb_crew');
        if(!crew) return { ok:false, error:'Please choose a crew count (0–4) to continue.' };
        const count = Math.max(0, Math.min(4, parseInt(String(crew.value || '0'), 10) || 0));
        state.racer.crewCount = count;

        if(count <= 0){
          state.racer.crewGeneralAdmission = null;
        } else {
          const ga = pickGeneralAdmissionVariant();
          if(ga && ga.id){
            state.racer.crewGeneralAdmission = { id: ga.id, title: 'General Admission - Crew', quantity: count };
          } else {
            state.racer.crewGeneralAdmission = null;
          }
        }

        return { ok:true };
      }
      if(stepId === 'spectator_pass'){
        const pass = getCheckedRadio('rb_spectator_pass');
        if(!pass) return { ok:false, error:'Please select a pass to continue.' };
        return { ok:true };
      }
      if(stepId === 'racer_classes'){
        const classes = getCheckedCheckboxes('rb_class_entry');
        const tech = getCheckedCheckboxes('rb_tech_card');
        if(classes.length === 0 && tech.length === 0) return { ok:false, error:'Select at least one class (or Test-N-Tune) to continue.' };

        // If user already said "yes" to points and we now have only 1 class, auto-apply points.
        if(state.racer.wantsPoints === 'yes'){
          const opts = getSelectedClassPointsOptions();
          state.racer.autoPoints = (opts.length === 1) ? ({ id: opts[0].id, title: opts[0].title }) : null;
        }
        return { ok:true };
      }
      if(stepId === 'racer_points_q'){
        const points = getCheckedRadio('rb_points');
        if(!points) return { ok:false, error:'Please choose Yes or No to continue.' };
        state.racer.wantsPoints = points.value;
        if(state.racer.wantsPoints === 'yes'){
          const opts = getSelectedClassPointsOptions();
          // If only one class selected, auto-add the points membership (no picker screen).
          state.racer.autoPoints = (opts.length === 1) ? ({ id: opts[0].id, title: opts[0].title }) : null;
          if(state.racer.autoPoints) clearManualPointsPick();
        } else {
          state.racer.autoPoints = null;
          clearManualPointsPick();
        }
        return { ok:true };
      }
      const ynMap = {
        spectator_golf_cart: 'rb_golf',
        racer_private_testing: 'rb_private_testing',
        racer_vip_parking: 'rb_vip_racer_parking',
        pit_side_parking: 'rb_pit_parking',
        rv_parking: 'rb_rv'
      };
      if(ynMap[stepId]){
        const v = getCheckedRadio(ynMap[stepId]);
        if(!v) return { ok:false, error:'Please choose Yes or No to continue.' };
      }
      return { ok:true };
    }

    function setCurrentIndexByStep(stepId){
      const ids = visibleStepIds();
      const idx = ids.indexOf(stepId);
      currentIdx = idx >= 0 ? idx : 0;
    }
    function nextStepId(){
      const ids = visibleStepIds();
      const curId = ids[currentIdx] || ids[0];
      const idx = Math.max(0, ids.indexOf(curId));
      return ids[Math.min(idx + 1, ids.length - 1)];
    }
    function prevStepId(){
      const ids = visibleStepIds();
      const curId = ids[currentIdx] || ids[0];
      const idx = Math.max(0, ids.indexOf(curId));
      return ids[Math.max(idx - 1, 0)];
    }

    function refreshSelectableForInput(input){
      if(!input) return;
      const label = input.closest ? input.closest('[data-rb-selectable]') : null;
      if(label) label.classList.toggle('is-selected', !!input.checked);
    }

    function refreshRadioGroup(name){
      if(!name) return;
      Array.from(root.querySelectorAll(`input[type="radio"][name="${name}"]`)).forEach(refreshSelectableForInput);
    }

    function bindSelectable(label){
      if(!label || label.dataset.rbBound === '1') return;
      const input = label.querySelector('input');
      if(!input) return;

      const update = () => {
        if(input.type === 'radio'){
          refreshRadioGroup(input.name);
        }else{
          refreshSelectableForInput(input);
        }
      };
      input.addEventListener('change', update);
      label.dataset.rbBound = '1';
      update();
    }

    function bindAllSelectables(scope){
      Array.from((scope || root).querySelectorAll('[data-rb-selectable]')).forEach(bindSelectable);
    }

    bindAllSelectables(root);

    async function addItemsToCart(items){
      const payload = { items: items.map(it => ({ id: it.id, quantity: it.quantity || 1 })) };
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if(!res.ok){
        const txt = await res.text().catch(() => '');
        throw new Error(`Cart add failed: ${res.status} ${txt}`);
      }
    }

    function restart(){
      root.querySelectorAll('input').forEach(input => {
        if(input.type === 'radio' || input.type === 'checkbox') input.checked = false;
      });
      // Refresh all selection UI (especially radios where unchecked won't fire change)
      Array.from(root.querySelectorAll('input[type="radio"][name]')).forEach(refreshSelectableForInput);
      Array.from(root.querySelectorAll('input[type="checkbox"][name]')).forEach(refreshSelectableForInput);
      if(statusEl) statusEl.textContent = '';
      state.role = null;
      state.racer.wantsPoints = null;
      state.racer.generalAdmission = null;
      state.racer.crewGeneralAdmission = null;
      state.racer.crewCount = 0;
      state.racer.autoPoints = null;
      currentFlow = flows.spectator;
      currentIdx = 0;
      show('role');
    }

    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-rb-action]');
      if(!btn) return;
      const action = btn.getAttribute('data-rb-action');
      const currentStepEl = steps.find(el => !el.hidden);
      const stepId = currentStepEl ? currentStepEl.getAttribute('data-rb-step') : 'role';

      if(action === 'restart') return restart();
      if(action === 'back'){
        const prev = prevStepId();
        setCurrentIndexByStep(prev);
        return show(prev);
      }
      if(action === 'next'){
        const result = validateAndCapture(stepId);
        if(!result.ok) return stepError(stepId, result.error);

        if(stepId === 'role'){
          const ids = visibleStepIds();
          currentIdx = 0;
          const first = ids[1] || ids[0];
          setCurrentIndexByStep(first);
          return show(first);
        }
        const next = nextStepId();
        setCurrentIndexByStep(next);
        return show(next);
      }
      if(action === 'add_to_cart'){
        const items = getPlannedItems();
        if(items.length === 0) return stepError('review','No items selected.');
        try{
          btn.disabled = true;
          if(statusEl) statusEl.textContent = 'Adding items to cart…';
          clearStepErrors();
          // Merge quantities per variant id (driver GA + crew GA share the same variant).
          const qtyById = new Map();
          items.forEach(it => {
            const id = Number(it.id);
            const qty = Number(it.quantity || 1);
            if(!id || qty <= 0) return;
            qtyById.set(id, (qtyById.get(id) || 0) + qty);
          });
          const cartItems = Array.from(qtyById.entries()).map(([id, quantity]) => ({ id, quantity }));
          await addItemsToCart(cartItems);
          if(statusEl) statusEl.textContent = 'Done. Redirecting to cart…';
          window.location.href = '/cart';
        }catch(err){
          console.error(err);
          stepError('review','Something went wrong adding items to the cart. Please try again.');
          if(statusEl) statusEl.textContent = '';
        }finally{
          btn.disabled = false;
        }
      }
    });

    show('role');
  });
}

// Rebate: receipt submission form (posts to backend/form service; no mailto UI)
function initRebateForm(){
  const form = document.getElementById('rebate-form');
  if(!form) return;

  const statusEl = document.getElementById('rebate-status');
  const submitBtn = document.getElementById('rebate-submit');

  function setStatus(msg, isError){
    if(!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.style.color = isError ? '#fecdd3' : '';
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    setStatus('', false);

    // Prefer an explicit action= URL; fall back to data-endpoint for backwards compatibility.
    const endpoint = String(form.getAttribute('action') || form.getAttribute('data-endpoint') || '').trim();
    if(!endpoint || endpoint.includes('REPLACE_ME')){
      setStatus('Form submission is not configured yet. Set rebate.html form action (or data-endpoint) to your form handler URL.', true);
      return;
    }

    // Honeypot: if filled, silently accept.
    const hp = form.querySelector('input[name="company"]');
    if(hp && String(hp.value || '').trim()){
      form.reset();
      setStatus('Thanks! Your submission has been received.', false);
      return;
    }

    const isGoogleScript = endpoint.includes('script.google.com/macros/s/');

    const receiptInput = document.getElementById('rebate-receipt');
    const receiptFile = receiptInput && receiptInput.files && receiptInput.files[0] ? receiptInput.files[0] : null;

    // If targeting Google Apps Script, we send JSON + base64 file (no multipart).
    // Apps Script Web Apps are happiest with JSON payloads from static sites.
    const maxBytes = 8 * 1024 * 1024; // ~8MB; base64 expands size ~33%
    if(isGoogleScript){
      if(!receiptFile){
        setStatus('Please attach your receipt file.', true);
        return;
      }
      if(receiptFile.size > maxBytes){
        setStatus('Receipt file is too large. Please upload a smaller image/PDF (max ~8MB).', true);
        return;
      }
    }

    const fd = isGoogleScript ? null : new FormData(form);

    const prevText = submitBtn ? submitBtn.textContent : '';
    if(submitBtn){
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
    }

    try{
      let res;

      if(isGoogleScript){
        setStatus('Uploading receipt…', false);

        const readAsDataUrl = (file) => new Promise((resolve, reject) => {
          const r = new FileReader();
          r.onerror = () => reject(new Error('Unable to read file.'));
          r.onload = () => resolve(String(r.result || ''));
          r.readAsDataURL(file);
        });

        const dataUrl = await readAsDataUrl(receiptFile);
        const comma = dataUrl.indexOf(',');
        const base64 = comma >= 0 ? dataUrl.slice(comma + 1) : '';
        const mime = String(receiptFile.type || '').trim() || 'application/octet-stream';

        // Collect form fields
        const firstName = String(document.getElementById('rebate-first-name')?.value || '').trim();
        const lastName = String(document.getElementById('rebate-last-name')?.value || '').trim();
        const email = String(document.getElementById('rebate-email')?.value || '').trim();
        const purchaseDate = String(document.getElementById('rebate-purchase-date')?.value || '').trim();

        const payload = {
          first_name: firstName,
          last_name: lastName,
          email,
          purchase_date: purchaseDate,
          receipt: {
            filename: receiptFile.name || 'receipt',
            mime,
            base64,
          },
          meta: {
            page: (window.location && window.location.href) ? window.location.href : '',
            userAgent: (navigator && navigator.userAgent) ? navigator.userAgent : '',
            submittedAt: new Date().toISOString(),
          }
        };

        // IMPORTANT:
        // Posting JSON with "Content-Type: application/json" triggers a CORS preflight (OPTIONS),
        // and Google Apps Script web apps often don't handle OPTIONS in a way browsers accept.
        // Send as text/plain to keep it a "simple request" (no preflight) and parse JSON server-side.
        res = await fetch(endpoint, {
          method: 'POST',
          redirect: 'follow',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'text/plain;charset=utf-8',
          },
          body: JSON.stringify(payload),
        });
      } else {
        res = await fetch(endpoint, {
          method: 'POST',
          body: fd,
          headers: {
            'Accept': 'application/json'
          }
        });
      }

      if(!res.ok){
        let detail = '';
        try{
          const data = await res.json();
          if(data && data.errors && data.errors.length){
            detail = data.errors.map(er => er && er.message ? er.message : '').filter(Boolean).join(' ');
          }
        }catch(_e){
          // ignore JSON parse errors
        }
        const msg = detail || ('Submission failed (' + res.status + ')');
        // Helpful hint for common hosted form limitation.
        if(msg.toLowerCase().includes('file uploads not permitted')){
          throw new Error('This form endpoint does not allow file uploads on its current plan/settings. Enable file uploads (or upgrade), or switch to a provider that supports uploads (e.g., Getform).');
        }
        throw new Error(msg);
      }

      // If response is JSON, try to read it (helps when Apps Script returns { ok, message }).
      try{
        const ct = String(res.headers.get('content-type') || '');
        if(ct.includes('application/json')){
          const data = await res.json();
          if(data && data.ok === false && data.message){
            throw new Error(String(data.message));
          }
        }
      }catch(err){
        // If JSON parsing fails, ignore; if it's a real error, rethrow
        if(err && err.message && String(err.message).toLowerCase().includes('unexpected token')){
          // ignore
        }else if(err instanceof Error){
          throw err;
        }
      }

      form.reset();
      setStatus('Submitted! Watch your email for any follow-up questions.', false);
    }catch(err){
      const msg = (err && err.message) ? err.message : 'Unable to submit right now.';
      if(String(msg).toLowerCase().includes('failed to fetch')){
        setStatus('Unable to submit (network/CORS). If using Google Apps Script, confirm the deployment is a Web App with access set to "Anyone" or "Anyone with the link".', true);
      } else {
        setStatus(msg, true);
      }
    }finally{
      if(submitBtn){
        submitBtn.disabled = false;
        submitBtn.textContent = prevText || 'Submit Receipt';
      }
    }
  });
}

// Header cart popout: view and edit the cart without leaving the current page.
function initHeaderCart(){
  const root = document.querySelector('[data-mini-cart]');
  const toggle = root ? root.querySelector('[data-mini-cart-toggle]') : null;
  const popout = root ? root.querySelector('[data-mini-cart-popout]') : null;
  const content = root ? root.querySelector('[data-mini-cart-content]') : null;
  const status = root ? root.querySelector('[data-mini-cart-status]') : null;
  const closeButton = root ? root.querySelector('[data-mini-cart-close]') : null;
  const overlay = document.querySelector('[data-mini-cart-overlay]');
  if(!root || !toggle || !popout || !content || !closeButton || !overlay) return;

  let open = false;
  let busy = false;
  let lastCart = null;
  const fallbackCurrency = root.getAttribute('data-cart-currency') || 'USD';

  function formatMoney(cents, currency){
    try{
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || fallbackCurrency
      }).format((Number(cents) || 0) / 100);
    }catch(_e){
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function setStatus(message){
    status.textContent = message || '';
    status.hidden = !message;
  }

  function setBusy(next){
    busy = !!next;
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function setCount(count){
    const value = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = String(value);
      badge.hidden = value === 0;
    });
    toggle.setAttribute('aria-label', 'Cart, ' + value + (value === 1 ? ' item' : ' items'));
  }

  function makeButton(label, action){
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.setAttribute('data-mini-cart-action', action);
    return button;
  }

  function renderCart(cart){
    lastCart = cart;
    content.textContent = '';
    setCount(cart && cart.item_count);

    if(!cart || !Array.isArray(cart.items) || cart.items.length === 0){
      const empty = document.createElement('div');
      empty.className = 'mini-cart-empty';
      const message = document.createElement('p');
      message.className = 'muted';
      message.textContent = 'Your cart is empty.';
      const tickets = document.createElement('a');
      tickets.className = 'btn primary';
      tickets.href = '/pages/buy-tickets';
      tickets.textContent = 'Event entry info';
      empty.append(message, tickets);
      content.appendChild(empty);
      return;
    }

    const items = document.createElement('div');
    items.className = 'mini-cart-items';

    cart.items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'mini-cart-item';
      article.setAttribute('data-mini-cart-key', item.key || '');

      if(item.image){
        const image = document.createElement('img');
        image.className = 'mini-cart-item-image';
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        article.appendChild(image);
      }else{
        const placeholder = document.createElement('div');
        placeholder.className = 'mini-cart-item-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        article.appendChild(placeholder);
      }

      const details = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'mini-cart-item-title';
      title.href = item.url || '/cart';
      title.textContent = item.product_title || item.title || 'Cart item';
      details.appendChild(title);

      if(item.variant_title && item.variant_title !== 'Default Title'){
        const meta = document.createElement('div');
        meta.className = 'mini-cart-item-meta';
        meta.textContent = item.variant_title;
        details.appendChild(meta);
      }

      const row = document.createElement('div');
      row.className = 'mini-cart-item-row';
      const qty = document.createElement('div');
      qty.className = 'mini-cart-qty';
      const decrease = makeButton('−', 'decrease');
      decrease.setAttribute('aria-label', 'Decrease quantity for ' + title.textContent);
      const input = document.createElement('input');
      input.type = 'number';
      input.min = '0';
      input.value = String(item.quantity || 0);
      input.setAttribute('data-mini-cart-input', '');
      input.setAttribute('aria-label', 'Quantity for ' + title.textContent);
      const increase = makeButton('+', 'increase');
      increase.setAttribute('aria-label', 'Increase quantity for ' + title.textContent);
      qty.append(decrease, input, increase);

      const price = document.createElement('strong');
      price.textContent = formatMoney(item.final_line_price, cart.currency);
      row.append(qty, price);

      const remove = makeButton('Remove', 'remove');
      remove.className = 'mini-cart-remove';
      remove.setAttribute('aria-label', 'Remove ' + title.textContent + ' from cart');
      details.append(row, remove);
      article.appendChild(details);
      items.appendChild(article);
    });

    const footer = document.createElement('div');
    footer.className = 'mini-cart-footer';
    const subtotal = document.createElement('div');
    subtotal.className = 'mini-cart-subtotal';
    const subtotalLabel = document.createElement('span');
    subtotalLabel.textContent = 'Subtotal';
    const subtotalValue = document.createElement('span');
    subtotalValue.textContent = formatMoney(cart.total_price, cart.currency);
    subtotal.append(subtotalLabel, subtotalValue);

    const actions = document.createElement('div');
    actions.className = 'mini-cart-actions';
    const viewCart = document.createElement('a');
    viewCart.className = 'btn';
    viewCart.href = '/cart';
    viewCart.textContent = 'View cart';
    const checkout = document.createElement('a');
    checkout.className = 'btn primary';
    checkout.href = '/checkout';
    checkout.textContent = 'Checkout';
    actions.append(viewCart, checkout);
    footer.append(subtotal, actions);
    content.append(items, footer);
  }

  async function fetchCart(){
    setBusy(true);
    setStatus('');
    try{
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if(!response.ok) throw new Error('Cart could not be loaded.');
      renderCart(await response.json());
    }catch(err){
      setStatus((err && err.message) ? err.message : 'Cart could not be loaded.');
    }finally{
      setBusy(false);
    }
  }

  function close(){
    if(!open) return;
    open = false;
    popout.hidden = true;
    overlay.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mini-cart-open');
    toggle.focus();
  }

  function show(){
    open = true;
    const header = document.querySelector('header');
    if(header && header.classList.contains('nav-open')){
      header.classList.remove('nav-open');
      const navToggle = header.querySelector('.nav-toggle');
      if(navToggle) navToggle.setAttribute('aria-expanded', 'false');
    }
    popout.hidden = false;
    overlay.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mini-cart-open');
    fetchCart();
    closeButton.focus();
  }

  async function updateQuantity(itemElement, quantity){
    if(busy || !itemElement) return;
    const key = itemElement.getAttribute('data-mini-cart-key');
    if(!key) return;
    setBusy(true);
    setStatus('');
    try{
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
      });
      const cart = await response.json();
      if(!response.ok) throw new Error(cart.description || 'Cart could not be updated.');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }catch(err){
      setStatus((err && err.message) ? err.message : 'Cart could not be updated.');
      if(lastCart) renderCart(lastCart);
    }finally{
      setBusy(false);
    }
  }

  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    if(open) close();
    else show();
  });
  closeButton.addEventListener('click', close);
  overlay.addEventListener('click', close);

  content.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mini-cart-action]');
    if(!button) return;
    const item = button.closest('[data-mini-cart-key]');
    const input = item ? item.querySelector('[data-mini-cart-input]') : null;
    const current = input ? Math.max(0, Number(input.value) || 0) : 0;
    const action = button.getAttribute('data-mini-cart-action');
    if(action === 'increase') updateQuantity(item, current + 1);
    if(action === 'decrease') updateQuantity(item, Math.max(0, current - 1));
    if(action === 'remove') updateQuantity(item, 0);
  });

  content.addEventListener('change', (event) => {
    const input = event.target.closest('[data-mini-cart-input]');
    if(!input) return;
    updateQuantity(input.closest('[data-mini-cart-key]'), input.value);
  });

  document.addEventListener('keydown', (event) => {
    if(open && event.key === 'Escape') close();
  });

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail;
    if(!cart) return;
    if(open) renderCart(cart);
    else setCount(cart.item_count);
  });

  document.addEventListener('mini-cart:close', close);
}

// Media partner application form (posts to backend/form service; no mailto UI)
function initMediaPartnerForm(){
  const form = document.querySelector('[data-media-partner-form]');
  if(!form) return;

  const statusEl = document.getElementById('media-partner-status');
  const submitBtn = document.getElementById('media-partner-submit');

  function setStatus(msg, isError){
    if(!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.style.color = isError ? '#fecdd3' : '';
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    setStatus('', false);

    const endpoint = String(form.getAttribute('action') || form.getAttribute('data-endpoint') || '').trim();
    if(!endpoint || endpoint.includes('REPLACE_ME')){
      setStatus('Form submission is not configured yet. Add the Google Apps Script web app URL in this page section settings.', true);
      return;
    }

    const hp = form.querySelector('input[name="website"]');
    if(hp && String(hp.value || '').trim()){
      form.reset();
      setStatus('Thanks! Your application has been received.', false);
      return;
    }

    const prevText = submitBtn ? submitBtn.textContent : '';
    if(submitBtn){
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    try{
      let res;
      const isGoogleScript = endpoint.includes('script.google.com/macros/s/');

      if(isGoogleScript){
        const fd = new FormData(form);
        const payload = {};
        fd.forEach((value, key) => {
          if(key === 'website') return;
          payload[key] = String(value || '').trim();
        });
        payload.meta = {
          page: (window.location && window.location.href) ? window.location.href : '',
          userAgent: (navigator && navigator.userAgent) ? navigator.userAgent : '',
          submittedAt: new Date().toISOString(),
        };

        res = await fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          redirect: 'follow',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'text/plain;charset=utf-8',
          },
          body: JSON.stringify(payload),
        });
      } else {
        res = await fetch(endpoint, {
          method: 'POST',
          body: new FormData(form),
          headers: {
            'Accept': 'application/json'
          }
        });
      }

      if(!isGoogleScript && !res.ok){
        throw new Error('Submission failed (' + res.status + ')');
      }

      try{
        const ct = String(res.headers.get('content-type') || '');
        if(ct.includes('application/json')){
          const data = await res.json();
          if(data && data.ok === false && data.message){
            throw new Error(String(data.message));
          }
        }
      }catch(err){
        if(err instanceof Error && !String(err.message || '').toLowerCase().includes('unexpected token')){
          throw err;
        }
      }

      form.reset();
      setStatus('Submitted! We will review your application and follow up by email.', false);
    }catch(err){
      const msg = (err && err.message) ? err.message : 'Unable to submit right now.';
      if(String(msg).toLowerCase().includes('failed to fetch')){
        setStatus('Unable to submit (network/CORS). If using Google Apps Script, confirm the deployment is a Web App with access set to "Anyone" or "Anyone with the link".', true);
      }else{
        setStatus(msg, true);
      }
    }finally{
      if(submitBtn){
        submitBtn.disabled = false;
        submitBtn.textContent = prevText || 'Submit Application';
      }
    }
  });
}

document.querySelectorAll('.tabs').forEach(group => {
  group.addEventListener('click', e => {
    const btn = e.target.closest('.tab');
    if(!btn) return;
    const id = btn.dataset.tab;
    const parent = group.parentElement;
    group.querySelectorAll('.tab').forEach(t => t.setAttribute('aria-selected', t===btn ? 'true' : 'false'));
    parent.querySelectorAll('.tabpanel').forEach(p => p.classList.remove('active'));
    const active = parent.querySelector('#'+id);
    if(active) active.classList.add('active');
    scheduleEqualizeClassCardHeights();
  });
});

// Points tab switch (top-level)
document.querySelectorAll('#points .tabs .tab').forEach(btn => {
  btn.addEventListener('click', () => {
    const id = btn.dataset.tab;
    const wrap = document.querySelector('#points');
    wrap.querySelectorAll('.tab').forEach(t => t.setAttribute('aria-selected', t===btn ? 'true' : 'false'));
    wrap.querySelectorAll('.tabpanel').forEach(p => p.classList.remove('active'));
    document.getElementById(id).classList.add('active');
  });
});

// Dynamic year
const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = new Date().getFullYear();

function scrollToAnchorId(id){
  if(!id) return;

  // Buy Tickets page uses <section id="passes"> as the top-of-page wrapper.
  // When navigating to #passes (especially from other pages), the sticky header
  // can cause the browser to land "below" the real top. Treat it as a scroll-to-top.
  if(id === 'passes'){
    window.__deadlineBannerFreezeUntil = Date.now() + 1200;
    try{
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }catch(_e){
      window.scrollTo(0, 0);
    }
    return;
  }

  const expander = window.__expandCollapsibleSection;
  const el = (typeof expander === 'function') ? expander(id) : document.getElementById(id);
  if(!el) return;

  // Smooth scrolling triggers many intermediate scroll positions; freeze the
  // deadline banner's auto-hide logic briefly so it can't "fight" the scroll.
  window.__deadlineBannerFreezeUntil = Date.now() + 1200;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Smooth anchor scrolling + expand target section on mobile
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const href = a.getAttribute('href');
    const id = href ? href.slice(1) : '';
    const el = document.getElementById(id);
    if(!el) return;
    e.preventDefault();
    scrollToAnchorId(id);
  });
});

// Initial + resize equal-height pass for class cards
function safeInit(name, fn){
  try{
    if(typeof fn === 'function') fn();
  }catch(err){
    // eslint-disable-next-line no-console
    console.warn('[init] '+name+' failed:', err);
  }
}

safeInit('scheduleEqualizeClassCardHeights', scheduleEqualizeClassCardHeights);
window.addEventListener('resize', scheduleEqualizeClassCardHeights);

// Init hamburger nav after the DOM exists
safeInit('initMobileNav', initMobileNav);

// Header cart popout
safeInit('initHeaderCart', initHeaderCart);

// Registration deadline countdown banner
safeInit('initRegistrationDeadlineCountdown', initRegistrationDeadlineCountdown);

// Hide banner on scroll down; show on scroll up
safeInit('initDeadlineBannerScrollHide', initDeadlineBannerScrollHide);

// Mobile: collapse/expand sections (Classes stays open)
safeInit('initMobileCollapsibleSections', initMobileCollapsibleSections);

// If page loads with a hash, expand + scroll to it on mobile
if(window.location && window.location.hash && window.location.hash.length > 1){
  const id = window.location.hash.slice(1);
  // Defer a tick so collapsible structure/state is applied first.
  if(id === 'passes'){
    // Override native fragment jump (keeps Buy Tickets page aligned to true top).
    try{
      const u = new URL(window.location.href);
      u.hash = '';
      history.replaceState(null, '', u.toString());
    }catch(_e){ /* ignore */ }
    setTimeout(() => window.scrollTo(0, 0), 0);
  }else{
    setTimeout(() => scrollToAnchorId(id), 0);
  }
}

// Render current year points table when configured, otherwise show TBD cards.
safeInit('renderCurrentYearStandingsFromXlsx', renderCurrentYearStandingsFromXlsx);

// Render 2025 archive points table
safeInit('render2025PointsFromXlsx', render2025PointsFromXlsx);

// Past races photo galleries (thumb strip + lightbox)
safeInit('initPastRacesPhotoGalleries', initPastRacesPhotoGalleries);

// External links should open a new tab
safeInit('initExternalLinksNewTab', initExternalLinksNewTab);

// Racer/Vendor: GA link derived from query param
safeInit('initRacerVendorGeneralAdmissionLink', initRacerVendorGeneralAdmissionLink);

// Buy Tickets: section jump menu
safeInit('initTicketsJumpMenu', initTicketsJumpMenu);

// Rebate receipt submission form
safeInit('initRebateForm', initRebateForm);

// Media partner application form
safeInit('initMediaPartnerForm', initMediaPartnerForm);

// Cart (auto-update)
safeInit('initCartAutoUpdate', initCartAutoUpdate);

// Race series builder
safeInit('initRaceSeriesCartBuilder', initRaceSeriesCartBuilder);
